module.exports = __webpack_public_path__ + "static/media/tuit_logo.f38d44cc.png";